import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const LostAidHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Eligibility Requirements not met'>
    You may lose financial aid because you didn't meet the income or academic requirements or are missing necessary
    paperwork
  </HelpModal>